function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  strokeWidth: 0.13102
}, React.createElement("path", {
  d: "m26.101 206.66 1.7535 0.0245 1.6668 2.2551-1.6178 1.6178v4.1319l-3.2846 0.0173"
}), React.createElement("path", {
  d: "m27.904 210.56-0.04903-3.8729"
}), React.createElement("path", {
  d: "m24.668 208.1c0.56656 0.0235 1.0943-0.42084 1.5198-1.4462"
}));

var SvgIcon = function SvgIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "10.583mm",
    height: "10.583mm",
    viewBox: "0 0 10.583334 10.583334",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, React.createElement("g", {
    transform: "translate(-19.368 -205.4)",
    fill: "none",
    stroke: "#2d5986"
  }, _ref2, React.createElement("g", {
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }, React.createElement("circle", {
    cx: 24.66,
    cy: 210.69,
    r: 5.2262,
    strokeWidth: 0.13102,
    style: {
      paintOrder: "markers stroke fill"
    }
  }), React.createElement("path", {
    d: "m24.644 205.53v10.315",
    strokeWidth: 0.13037,
    style: {
      paintOrder: "markers stroke fill"
    }
  }), React.createElement("path", {
    d: "m24.632 208.62a1.9487 1.9487 0 0 0 -1.9487 1.9487 1.9487 1.9487 0 0 0 1.9487 1.9487 1.9487 1.9487 0 0 0 0.01225 -4.6e-4v-3.8964a1.9487 1.9487 0 0 0 -0.01225 -5.9e-4z",
    strokeWidth: 0.13102,
    style: {
      paintOrder: "markers stroke fill"
    }
  }), React.createElement("path", {
    d: "m23.214 206.47-0.0717 2.2308-1.9557-1.0757 1.1458 1.9154-2.2268 0.15237 1.9994 0.99193-1.7909 1.332 2.2183-0.24652-0.78644 2.0888 1.7329-1.4067 0.46771 2.1824 0.6973-2.1202v-4.6141l-0.36632 0.53166z",
    strokeWidth: 0.13102,
    style: {
      paintOrder: "markers stroke fill"
    }
  }))));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon.48d64295.svg";
export { ForwardRef as ReactComponent };